// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__21LsC","btnRed":"styles_btnRed__GuYQu","formContent":"styles_formContent__1NfUE","form":"styles_form__3-VWQ"};